/**
 * Formats a hex color string into an array of RGB values.
 * @param {string} hex - The hex color string.
 * @returns {number[]} An array containing the RGB values.
 */
function formatHexColor(hex) {
  const cleanHex = hex.startsWith('#') ? hex.slice(1) : hex;

  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  return [r, g, b];
}

/**
 * Tells us if the button background color is light
 * @param {string} buttonColor
 * @returns
 */
export function isLightBackground(buttonColor) {
  const [r, g, b] = formatHexColor(buttonColor);

  // Calculate the perceived brightness using the HSP (Highly Sensitive Pooled) color model
  // This formula accounts for human perception of different colors' brightness.
  const hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
  );

  // You can adjust this threshold value.
  // A common threshold for determining "dark" vs "light" is around 127.5 (half of 255).
  // Lower values make it more likely to be classified as "dark".
  const threshold = 127.5; 

  return hsp > threshold;
}

/**
 * Gets button style for selected option
 * @param {string} buttonColor
 * @returns
 */
export function getActionButtonStyle(buttonColor, defaultStyle) {
  let style = defaultStyle || "background: #2544b7;";

  if (buttonColor) {
    if (isLightBackground(buttonColor)) {
      style = "background: " + buttonColor + "; color: black;";
    } else {
      style = "background: " + buttonColor + "; color: white;";
    }
  }

  return style;
}
